import { c as _c } from "react/compiler-runtime";
import React from "react";
interface HorizontalTimelineDotProps {
  readonly isNext: boolean;
  readonly isPast: boolean;
}

/**
 * Renders a dot for the horizontal timeline
 */
export const HorizontalTimelineDot: React.FC<HorizontalTimelineDotProps> = t0 => {
  const $ = _c(2);
  const {
    isNext,
    isPast
  } = t0;
  const t1 = `tw-w-3 tw-h-3 tw-rounded-full ${isNext ? "tw-bg-primary-400 tw-ring-2 tw-ring-primary-400/30" : isPast ? "tw-bg-iron-600" : "tw-bg-iron-900 tw-border tw-border-solid tw-border-iron-700"}`;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};